import * as req from 'api/actions';
import * as c from './constant';

export const getFeedbackFormsCore = (payload, callback) =>
  req.item(
    c.GET_FEEDBACK_FORMS_CORE,
    '/api/v1/administrators/feedback_forms/core',
    payload,
    callback,
  );

export const getFeedbackDataForFeedback = (payload, callback) =>
  req.item(
    c.GET_FEEDBACK_DATA_FOR_FEEDBACK,
    '/api/v1/administrators/feedback_forms/data_for_feedback',
    payload,
    callback,
  );

export const submitFeedback = (payload, callback) =>
  req.create(
    c.SUBMIT_FEEDBACK,
    `/api/v1/administrators/feedback_forms/core`,
    payload,
    callback
  );